<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='onSave') 保存
  .contents-container
    el-form.c-form(ref='form', :model='form' v-loading='LOADING')
      header.c-form__header
        h1 必須項目
      .c-form__body
        section.c-form__item
          header.c-form__item__header.--top
            h1 バナー動画
          .c-form__item__body
            el-button.u-margin__bottom--m(size='small', type='primary' icon='el-icon-plus' @click='onAdd') 追加
            draggable(v-model='form.banner' element='div')
              el-row(v-for='(item, index) in form.banner' :gutter='20' :key='index')
                el-col(:span='12')
                  el-form-item
                    upload-movie(:item='item')

        section.c-form__item
          header.c-form__item__header
            h1 Featured
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='showAddWorksModal()'  :disabled='form.feature.length > 9') 追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='deleteWork()' :disabled='form.feature.length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                draggable.c-list__works(v-model='form.feature' element='ul')
                  li(v-for='(i, index) in form.feature' :key='index')
                    template(v-if='getWorkImageUri(form.feature[index])')
                      img.c-thumb__item--s(:src='getWorkImageUri(form.feature[index])')
                    template(v-else)
                      .c-thumb__item--s
                        p no image
                    | {{getWorkString(form.feature[index])}}
            el-row(:gutter='20')
              el-col(:span='12')
                p.caption.u-margin__top--s 最大10件設定、ステータスが非公開の場合は表示されません。
  modal-add-works-element(:visible='modalvisible.works' @hideModal='hideWorksModal')
</template>

<script type='text/javascript'>
import Sticky from '@/components/Element/Sticky'
import UploadMovie from '@/components/Element/Upload/Movie'
import ModalAddWorksElement from '@/components/Element/Modal/AddFeaturedWorksElement'
import form from '@/mixins/form'
import draggable from 'vuedraggable'
export default {
  name: 'PagesTopDetail',
  mixins: [form],
  data () {
    return {
      modalvisible: {
        works: false
      },
      index: null,
      form: {
        banner: [],
        feature: []
      }
    }
  },
  methods: {
    onAdd () {
      const addBanner = {
        uri: null,
        link: null,
        target: 'self'
      }
      this.form.banner.push(addBanner)
    },
    showAddWorksModal (index) {
      this.modalvisible.works = true
    },
    /**
     * @param {Object} data
     */
    hideWorksModal (data) {
      this.modalvisible.works = false
      if (data.id) {
        this.form.feature.push({
          id: data.id
        })
      }
    },
    deleteWork () {
      // 最後の要素から削除
      this.form.feature.pop()
    }
  },
  created () {
    this.init()
  },
  components: {
    Sticky,
    UploadMovie,
    ModalAddWorksElement,
    draggable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Top/index.vue